import update from 'immutability-helper';
import _ from 'lodash';
import {
  SingleFileUploadPayload,
  UploadingFile,
} from '../../types/media-assets';

import { Action } from '../redux.types';
import { FILES_ACTIONS } from './files.actions';

const normalizeFile = ({
  id,
  path,
  file,
}: SingleFileUploadPayload): UploadingFile => ({
  id,
  path,
  name: file.name,
  size: file.size,
  progress: 0,
  dateCreated: new Date().toISOString(),
});

const getIndex = (files, id) => _.findIndex(files, { id });

export type FilesProgressState = UploadingFile[];

const defaultState: FilesProgressState = [];

export const uploading = (
  state: FilesProgressState = defaultState,
  { type, payload }: Action,
): any => {
  switch (type) {
    case FILES_ACTIONS.FILE_CREATING: {
      const uploadingFile: SingleFileUploadPayload = payload;
      return [...state, normalizeFile(uploadingFile)];
    }

    case FILES_ACTIONS.FILE_UPLOAD_PROGRESS:
      return update(state, {
        [getIndex(state, payload.clientId)]: {
          progress: {
            $set: Math.round((payload.loaded / payload.total) * 100),
          },
        },
      });

    // TODO: handle file uploading errors
    case FILES_ACTIONS.FILE_UPLOAD_ERROR:
    case FILES_ACTIONS.FILE_UPLOAD_SUCCESS:
    case FILES_ACTIONS.FILE_CREATE:
      return _.reject(state, { id: payload.clientId });

    default:
      return state;
  }
};
